import { Advertisement } from "@apuestes/types";
import { initialAdvertisementState } from "../../../../_metronic/helpers";
import { createSlice } from "@reduxjs/toolkit";
import { apuestesAPI } from "../../services/apuestesAPI";

const advertisementSlice = createSlice({
    name: "advertisement",
    initialState: {
        meta: { fetch: false, id: -1 },
        value: initialAdvertisementState
    },
    reducers: {},
    extraReducers(builder) {
        builder
        .addMatcher(apuestesAPI.endpoints.getModelById.matchFulfilled, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'advertisements') {
              state.value = action.payload as unknown as Advertisement;
          }
        })
        .addMatcher(apuestesAPI.endpoints.updateModel.matchFulfilled, (state, action) => {
          if (action.meta.arg.originalArgs.model === 'advertisements') {
              state.value = action.payload as unknown as Advertisement;
          }
        })
      },
});

export default advertisementSlice.reducer;
